import store from "../lib/store/index.js";
import { cloneDeep } from "lodash-es";

const state = {
	...store.state,
	resultView: null,
	siteName: null,
	aboveMdBreakpoint: window.innerWidth > 768,
	firstRequestSent: false,
};
const getters = {
	...store.getters,
	search: state => state.search,
	resultView: state => state.resultView,
	siteName: state => state.siteName,
	aboveMdBreakpoint: state => state.aboveMdBreakpoint,
	firstRequestSent: state => state.firstRequestSent,
};
const mutations = {
	...store.mutations,
	setStateValue(state, payload) {
		if (typeof payload[1] == "object") {
			let newObj = cloneDeep(payload[1]);
			state[payload[0]] = newObj;
		} else {
			state[payload[0]] = payload[1];
		}
	},
	setFilterValueWithId(state, {id, value}) {
		let groups = cloneDeep(state.search.filters);
		const recurse = filters => {
      return filters.some(f => {
        if (f.id === id) return this.commit("setFilterValue", {filter: f, value}), true;
        if (f.filters && f.filters.length) return recurse(f.filters);
        return false;
      });
    };
    groups.some(g => {
      return recurse(g.filters);
    });
	}
};
const actions = {
	...store.actions,
};

export default {
	state,
	getters,
	mutations,
	actions
};